import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessageCenter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 21,
	viewBox: "0 0 22 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.24 0.00221906H15.74C17.1118 -0.0380807 18.4428 0.471915 19.4365 1.4186C20.4301 2.36529 21.0039 3.67004 21.03 5.04222V12.6322C20.9483 15.4531 18.6116 17.6827 15.79 17.6322H14.17C13.7628 17.6333 13.3775 17.8168 13.12 18.1322L11.59 20.0822C11.3337 20.3994 10.9478 20.5837 10.54 20.5837C10.1322 20.5837 9.7463 20.3994 9.49 20.0822L7.91 18.0922C7.6525 17.7768 7.2672 17.5933 6.86 17.5922H5.24C2.41843 17.6427 0.0817429 15.4131 0 12.5922V5.00222C0.0763705 2.17899 2.4163 -0.0537603 5.24 0.00221906ZM15.75 16.1322C17.7585 16.1827 19.4301 14.6004 19.49 12.5922V5.04222C19.4301 3.02999 17.7523 1.44617 15.74 1.50222H5.24C3.22766 1.44617 1.54989 3.02999 1.49 5.04222V12.5922C1.54989 14.6044 3.22766 16.1883 5.24 16.1322H6.86C7.7271 16.1324 8.5473 16.5259 9.09 17.2022L10.49 18.9822L11.89 17.2022C12.4327 16.5259 13.2529 16.1324 14.12 16.1322H15.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.73999 6.96222C6.32578 6.96222 5.98999 7.29801 5.98999 7.71222V10.1122C5.98999 10.5264 6.32578 10.8622 6.73999 10.8622C7.1542 10.8622 7.48999 10.5264 7.48999 10.1122V7.71222C7.48999 7.29801 7.1542 6.96222 6.73999 6.96222V6.96222Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.49 6.96222C10.0758 6.96222 9.73999 7.29801 9.73999 7.71222V10.1122C9.73999 10.5264 10.0758 10.8622 10.49 10.8622C10.9042 10.8622 11.24 10.5264 11.24 10.1122V7.71222C11.24 7.29801 10.9042 6.96222 10.49 6.96222V6.96222Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.24 6.96222C13.8258 6.96222 13.49 7.29801 13.49 7.71222V10.1122C13.49 10.5264 13.8258 10.8622 14.24 10.8622C14.6542 10.8622 14.99 10.5264 14.99 10.1122V7.71222C14.99 7.29801 14.6542 6.96222 14.24 6.96222V6.96222Z",
			fill: "currentColor"
		})
	]
});
export default SvgMessageCenter;
